exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PrimaryIcon__favoriteIcon___2aW5q {\n  margin-top: 6px;\n  width: 24px;\n  height: 21.6px;\n  display: inline-block; }\n", ""]);

// exports
exports.locals = {
	"favoriteIcon": "PrimaryIcon__favoriteIcon___2aW5q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/FavoriteButton/styles/PrimaryIcon.scss
// module id = 3903
// module chunks = 6